import { gql } from '@apollo/client'
import { JOB_AREA_ALERT_FIELDS } from '../queries/job-area-alert.query'

// Arguments are top-level (no input object). Limits: 1–10 "City, ST" cities, radius 1–200, name ≤ 100, 20 alerts each.
export const CREATE_JOB_AREA_ALERT_MUTATION = gql`
	mutation createJobAreaAlert($cities: [String!]!, $name: String, $radiusMiles: Int, $enabled: Boolean) {
		createJobAreaAlert(cities: $cities, name: $name, radiusMiles: $radiusMiles, enabled: $enabled) {
			${JOB_AREA_ALERT_FIELDS}
		}
	}
`

// Partial: only the variables sent are applied; an explicit `name: null` clears the name.
export const UPDATE_JOB_AREA_ALERT_MUTATION = gql`
	mutation updateJobAreaAlert($id: ID!, $name: String, $cities: [String!], $radiusMiles: Int, $enabled: Boolean) {
		updateJobAreaAlert(id: $id, name: $name, cities: $cities, radiusMiles: $radiusMiles, enabled: $enabled) {
			${JOB_AREA_ALERT_FIELDS}
		}
	}
`

export const DELETE_JOB_AREA_ALERT_MUTATION = gql`
	mutation deleteJobAreaAlert($id: ID!) {
		deleteJobAreaAlert(id: $id) {
			success
		}
	}
`
